export default {
  props: [
    'errors',
    'value',
    'label',
    'placeholder',
    'addon',
    'textarea',
    'type',
    'mode',
    'objectKey',
  ],
  methods: {
    updateValue(val) {
      this.$emit('input', val)
      if (!!val) {
        this.$emit('changeFocus', this.objectKey)
      }
    },
    focus() {
      this.$refs.input.select()
    },
    focusManual() {
      // this.$refs.input.focus();
      this.$refs.input.select()
    },
    focusOut() {
      this.$refs.fakeInput.focus()
    },
    focusBack() {
      this.$emit('focusBack', this.objectKey)
    },
  },
}
